module.exports = __webpack_public_path__ + "img/3-low.c19a0cca.jpg";